import React from 'react';
import { getCdnImage } from 'functions';

interface IProps {
  topBanner: string;
}

// tslint:disable-next-line:variable-name
export const Header: React.FC<IProps> = props => {
  const bannerUrl = getCdnImage(props.topBanner);
  const image = bannerUrl && bannerUrl.includes('data:') ? props.topBanner : bannerUrl;

  return (
    <section className="banner-header">
      <div className="header">{image && <img alt="" src={image} />}</div>
    </section>
  );
};
